export enum EBootstrapActions {
  BOOTSTRAP_APP = 'BOOTSTRAP_APP',
}
